module.exports = __webpack_public_path__ + "img/carousel-image-4.87d746ba.png";